import {IPatient} from "@/domain/IPatient";
import { db } from '@/infraestructure/datasource';
import {Patient} from '@/domain/entities/Patient';
import {MedicalQuestionResponse, MedicalBackground} from '@/domain/entities/MedicalBackground';
import {MedicalQuestion} from '@/domain/entities/MedicalQuestion';
import {DiaryQuestion, Diaries} from '@/domain/entities/DiaryQuestion';
// import {pprint} from '@/helpers/pprint';

export class PatientRepository implements IPatient {

	static get key() { return  'PatientRepository' }

	_db : typeof db;

	constructor() {
		this._db = db;
	}

	answerDiaryQuestion(questionId: string, message: string, createdAt: string): void {
		console.log(questionId, message, createdAt);
		throw new Error("Method not implemented.");
	}

	async fetchPersonalInformation(userId : string, fromLocal: boolean):Promise<Patient> {
		// window.localStorage.setItem('userId', patientId)
		if (fromLocal) {
			let userLocal = window.localStorage.getItem('user')
			if (userLocal === null) {
				return await this.fetchPersonalInformation(userId, false)
			} else {
				let patient = JSON.parse(userLocal!) as Patient
				return patient
			}
		} else {
			let patientDoc = await db.collection('patients').doc(userId).get()
			let patientData = patientDoc.data()
			patientData!.id = patientDoc.id
			let p = patientData as Patient
			if (!p.emergencyContact) {
				p.emergencyContact = {
					name: '', phoneNumber: ''
				}
			}
			
			window.localStorage.setItem('user', JSON.stringify(p))
			return p
		}
	}
	
	fetchMedicalBackground(patientId: string): void {
		console.log(patientId);
		throw new Error("Method not implemented.");
	}
	fetchMeasurements(patientId: string): void {
		console.log(patientId);
		throw new Error("Method not implemented.");
	}

	async fetchDiaryQuestions(): Promise<DiaryQuestion[]> {
		let response = await db.collection('diary_questions').get()
		let diaryQuestions = response.docs.map((d) : DiaryQuestion => {
			let dd = { ...d.data(), id: d.id } as DiaryQuestion
			return dd
		})

		return diaryQuestions
	}

	async fetchAndFormatHealthInformation(userId : string) : Promise<MedicalQuestionResponse[]> {
		let medicalQuestions : MedicalQuestion[] = await db.collection('health_questions').get()
		.then((querySnapshot) => {
			return querySnapshot.docs.map(doc => {
				return <MedicalQuestion>{
					questionId: doc.id,
					...doc.data()
				}
			})
		}) 
		
		
		let patientDoc = await db.collection('patients').doc(userId).get()
		let patientData = patientDoc.data() as Patient

		let questions : MedicalQuestionResponse[] = []
		if (patientData.healthBackground !== undefined) {
			questions = patientData.healthBackground?.map((hb) => {
				let mq : MedicalQuestion | undefined = medicalQuestions.find((m) => m.questionId === hb.questionId)
				if (mq === undefined) {
					throw "MedicalQuestion Not Found";
				}
				const question : MedicalQuestionResponse = {
					...mq!,
					...hb,
				}
				return question
			})
		} else {
			questions = medicalQuestions.map((mq) : MedicalQuestionResponse => {
				const hb : MedicalQuestionResponse = {
					answer: '',
					...mq
				}
				return hb
			})
			patientData.healthBackground = questions.map((q) => <MedicalBackground>{...q})
		}
		return questions
	}

	async updatedData(p : Patient) : Promise<any | undefined> {
		try {
			await db.collection('patients').doc(p.id).set(
				p,
				{ merge: true, }
			)	
		} catch (error) {
			return error 
		}
	}

	async updateDiary(userId : string, qas: Diaries) {
		try {
			await db.collection('patients').doc(userId).set(
				{ diaries : qas },
				{ merge: true, }
			)	
		} catch (error) {
			return error 
		}

	}

	async addLikertSurvey(patient: Patient, score: number) {
		try {
			let createdAt = new Date()
			// const newLikertRecord = {
			// 	date: createdAt.toUTCString(),
			// 	score,
			// }
			// let likertRecords = patient.likertRecords || []
			// likertRecords.push(newLikertRecord)

			// await db.collection('patients').doc(patient.id).set(
			// 	{ likertRecords },
			// 	{ merge: true, }
			// )

			const _newLikertRecord = {
				date: createdAt,
				score,
			}
			await db.collection(`patients/${patient.id}/likert_records`).add(_newLikertRecord)	
			// patient.likertRecords = likertRecords
		} catch (error) {
			return error 
		}
	}
}
